<div *ngIf="object!=null" [ngSwitch]="type">
  <ng-container *ngSwitchDefault>
    <div class="d-flex" *ngFor="let key of Object.keys(object)">
      <div class="no-wrap fw-bold mr-1">{{key}}:</div>
      <object-renderer [object]="object[key]"></object-renderer>
    </div>
  </ng-container>
  <div *ngSwitchCase="'string'" copy>{{object}}</div>
  <div *ngSwitchCase="'number'" copy>{{object|number}}</div>
  <div *ngSwitchCase="'boolean'">{{object}}</div>
</div>